module.exports = __webpack_public_path__ + "de66b13e8cda09b3b40249d0a330af92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Logo.png
// module id = ./src/assets/Logo.png
// module chunks = 0